class BackInStockModal extends ModalDialog {
  constructor() {
    super();
  
    this.addEventListener("submit", this.subscribe.bind(this));
    // console.log(userCountry);
  
    const phoneInput = this.querySelector("[data-phone-number]");
    console.log(BryanAnthonys.isDomesticVisitor());
    if (!BryanAnthonys.isDomesticVisitor() && phoneInput) {
      phoneInput.hidden = true; 
      phoneInput.removeAttribute("required"); 
    } else if (phoneInput) {
      phoneInput.hidden = false; 
      const modalElement = document.querySelector(".back-in-stock-modal");
      if (modalElement?.getAttribute("data-required-sms") === "true") {
          phoneInput.setAttribute("required", "true");
      }
      phoneInput.addEventListener("input", this.formatPhoneNumber.bind(this));
      phoneInput.addEventListener("input", this.validatePhoneNumber.bind(this));
      phoneInput.addEventListener("keydown", this.handleBackspace.bind(this));
      
    }
  }

  formatPhoneNumber(event) {
    let input = event.target;
    let value = input.value.trim();
  
    if (value && !value.startsWith("+1")) {
      value = "+1" + value.replace(/^\+/, ""); 
      input.value = value; 
    }
  }
  
  handleBackspace(event) {
    const input = event.target;
    if (event.key === "Backspace" && input.value === "+1") {
      input.value = ""; 
      event.preventDefault(); 
    }
  }
  
  show(variantName, variantId, opener = null) {
    this.querySelector("[data-variant-id]").setAttribute("value", variantId);
    const variantTitleElement = this.querySelector("[data-variant-title]");
    if (variantTitleElement) {
      variantTitleElement.innerText = variantName;
    }

    if (document.documentElement.classList.contains("eu-visitor")) {
      this.querySelector("[data-subscribe-to-newsletter]").checked = false;
    }

    super.show(opener);
  }

  validatePhoneNumber() {
    const phoneInput = this.querySelector("[data-phone-number]");
    if (phoneInput) {
      const phoneNumber = phoneInput.value.trim();
      const phoneRegex = /^\+1\d{10}$/;

      if (!phoneRegex.test(phoneNumber)) {
        phoneInput.setCustomValidity(
          "Please enter a valid US phone number."
        );
      } else {
        phoneInput.setCustomValidity(""); // Clear error when valid
      }
      phoneInput.reportValidity(); // Show or hide validation message dynamically
    }
  }

  validateEmail() {
    const emailInput = this.querySelector("[data-email-address]");
    if (emailInput) {
      const email = emailInput.value.trim();
      const emailRegex =
        /^[^\s@]+@(?!.*\.\.)(?!.*\.@)[^\s@.]+(\.[^\s@.]+)*\.[a-zA-Z]{2,}$/;

      if (!emailRegex.test(email)) {
        emailInput.setCustomValidity("Enter a valid email address.");
      } else {
        emailInput.setCustomValidity(""); // Clear error when valid
      }
      emailInput.reportValidity(); // Show or hide validation message dynamically
    }
  }

  subscribe(event) {
    event.preventDefault();
    const form = event.target;

    const modalElement = document.querySelector(".back-in-stock-modal");

    const button = form.querySelector('[type="submit"]');
    button.classList.add("loading");

    const emailInput = form.querySelector("[data-email-address]");
    const phoneInput = form.querySelector("[data-phone-number]");

    const emailRequired =
      modalElement.getAttribute("data-required-email") === "true";
    const phoneRequired =
      modalElement.getAttribute("data-required-sms") === "true";

    let email = emailInput ? emailInput.value.trim() : "";
    let phoneNumber = phoneInput ? phoneInput.value.trim() : "";

    if (emailInput) {
      email = emailInput.value.trim();
      if (emailRequired && email !== "") {
        // Validate before proceeding
        this.validateEmail();
        if (!emailInput.checkValidity()) {
          button.classList.remove("loading");
          return;
        }
      }
    }

    if (phoneInput) {
      phoneNumber = phoneInput.value.trim();
      if (phoneRequired && phoneNumber !== "") {
        // Validate before proceeding
        this.validatePhoneNumber();
        if (!phoneInput.checkValidity()) {
          button.classList.remove("loading");
          return;
        }
      }
    }

    const variant = form.querySelector("[data-variant-id]").value;
    const enabledChannels = [];
    const enableSMS = modalElement.getAttribute("data-enable-sms") === "true";
    const enableEmail =
      modalElement.getAttribute("data-enable-email") === "true";

    if (enableEmail && email !== "") {
      enabledChannels.push("EMAIL");
    }
    if (enableSMS && phoneNumber !== "") {
      enabledChannels.push("SMS");
    }

    const bodyData = JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                ...(emailInput && email !== "" && { email: email }),
                ...(phoneInput &&
                  phoneNumber !== "" && { phone_number: phoneNumber }),
              },
            },
          },
          channels: enabledChannels,
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    });

    const apiVersion = modalElement.getAttribute("data-api-version");
    const apiEndpoint = modalElement.getAttribute("data-api-endpoint");
    const listKey = modalElement.getAttribute("data-account-key");

    const options = {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: apiVersion,
        "content-type": "application/vnd.api+json",
      },
      body: bodyData,
    };

    fetch(
      `https://a.klaviyo.com/client${apiEndpoint}?company_id=${listKey}`,
      options
    )
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
      })
      .then(() => {
        if (emailInput) {
          form.querySelector("[data-email-address]").value = "";
        }
        if (phoneInput) {
          form.querySelector("[data-phone-number]").value = "";
        }
        this.showSuccessMessage();
      })
      .catch((error) => {
        console.error(error);
        this.showErrorMessage();
      })
      .finally(() => button.classList.remove("loading"));
  }

  showErrorMessage() {
    this.hideMessages();
    this.querySelector(
      "[data-feedback] .status-banner--error"
    ).classList.remove("hidden");
  }

  showSuccessMessage() {
    this.hideMessages();
    this.querySelector(
      "[data-feedback] .status-banner--success"
    ).classList.remove("hidden");
  }

  hideMessages() {
    this.querySelectorAll("[data-feedback] .status-banner").forEach((banner) =>
      banner.classList.add("hidden")
    );
  }
}

customElements.define("back-in-stock-modal", BackInStockModal);

class BackInStockOpener extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      const backInStockModal = document.querySelector("back-in-stock-modal");

      if (!backInStockModal) {
        return;
      }

      backInStockModal.show(
        this.dataset.productName,
        this.dataset.variantId,
        this.querySelector("button")
      );
    });
  }
}

customElements.define("back-in-stock-opener", BackInStockOpener);
